import { gql } from '@apollo/client'

export default gql`
  fragment CountrySettings on CountrySettingsDto {
    id
    country
    defaultRankingTopPercentage
    defaultRankingLowPercentage
    defaultRankingLowPercentageIsBlocker
    defaultRankingRankingIsDisabled
    isIdVWeightEnabled
    cutOffDay
    employeeLevelsSet
    isDeductionEnabled
    hasNationalContractReferenceLevel
    hasGovernmentJobTitleReferenceLevel
    isMonthlySalaryDisplayed
    monthlySalaryMonthsInYear
    flexibleProrataManagementEnabled
    selfReflectionAndEvaluationAlwaysVisible
    createTargetReport
    paymentsAndChangesDisclaimerVisible
    isDateOfBirthVisible
    isAgePyramidVisible
    skillStatusBlocker
    defaultKudosFeatureEnabled
    isBranchOfficeVisible
  }
`
